<script>
import InterviewQuestion from './InterviewQuestion.vue';

export default {
    components: {
        InterviewQuestion
    },

    props: {
        defaultInterviewQuestions: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        },
    },

    data() {
        return {
            interviewQuestions: [...this.defaultInterviewQuestions]
        }
    },

    methods: {
        addInterviewQuestion() {
            this.interviewQuestions.push({
                title: '',
                phase: '',
                asnwer_type: '',
                is_trigger: false,
                parent_id: null,
            })
        },
        removeIntervieQuestion(index) {
            this.interviewQuestions.splice(index, 1)
        },
        parentQuestions(index) {
            const thisQuestion = this.interviewQuestions[index]

            return this.interviewQuestions
                .filter((_, i) => i !== index)
                .filter(question => question.answer_type == 'yes_no')
                .filter(question => question.id !== null && question.id !== undefined)
                .filter(question => question.parent_id !== thisQuestion.id)
        }
    }
}
</script>

<template>
    <div>
        <interview-question
            v-for="(interviewQuestion, i) in interviewQuestions"
            :key="i"
            :index="i"
            :interview-question="interviewQuestion"
            :parent-questions="parentQuestions(i)"
            :disabled="disabled"
            @remove="() => removeIntervieQuestion(i)"
        />

        <div v-if="!disabled" @click="addInterviewQuestion" class="add-button"><i class="fas fa-plus-circle"></i></div>

        <input v-if="interviewQuestions.length === 0" name="interview_questions" value="" type="hidden" />
    </div>
</template>